import request from '@/utils/request'

const userWechat = {
  name: 'userWechat',
  state: {
    isUserWechatDetailLoading: false,
    userWechatDetailData: {},
    customerId: 0,
    generalUserDetailData: {}
  },

  mutations: {
    SET_IS_MODULES_USERWECHAT_DETAIL_LOADING: (state, data) => {
      state.isUserWechatDetailLoading = data
    },
    SET_MODULES_USERWECHAT_DETAIL_DATA: (state, data) => {
      state.userWechatDetailData = data
    },
    SET_MODULES_USERWECHAT_CUSTOMER_ID: (state, data) => {
      state.customerId = data
    },
    SET_MODULES_USERWECHAT_GENERALUSER_DETAIL_DATA: (state, data) => {
      state.generalUserDetailData = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    queryUserWechatDetailData({ commit }, id) {
      commit('SET_IS_MODULES_USERWECHAT_DETAIL_LOADING', true)
      commit('SET_MODULES_USERWECHAT_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/userWechat/userWechatDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_USERWECHAT_DETAIL_LOADING', false)
          commit('SET_MODULES_USERWECHAT_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_USERWECHAT_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetUserWechatDetailData({ commit }) {
      commit('SET_MODULES_USERWECHAT_DETAIL_DATA', {})
    },
    //  重置账号新增页面数据
    setUserWechatCustomerId({ commit }, id) {
      commit('SET_MODULES_USERWECHAT_CUSTOMER_ID', id)
    },
    setUserWechatDetailData({ commit }, data) {
      commit('SET_MODULES_USERWECHAT_DETAIL_DATA', data)
    },
    //  重置普通用户新增页面数据
    resetUserWechatGeneralUserDetailData({ commit }, data) {
      commit('SET_MODULES_USERWECHAT_GENERALUSER_DETAIL_DATA', {})
    }
  }
}

export default userWechat
